var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.getPriceData.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c("CustomMultiSelect", {
              ref: "selectedCountries",
              attrs: {
                records: Object.values(_vm.countries),
                options: { placeholder: "Выберите страну" },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchTitle,
                    expression: "searchTitle",
                  },
                ],
                staticClass: "form-control search_value",
                attrs: {
                  type: "text",
                  placeholder: "Текст для поиска",
                  required: "",
                },
                domProps: { value: _vm.searchTitle },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.searchTitle = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group-append" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Поиск",
                      type: "submit",
                      loading: _vm.loading,
                      color: _vm.$constants.LOADING_COLOR,
                      onClick: () => {},
                      className: "btn btn-outline-info br-0",
                    },
                  }),
                  _vm._v(" "),
                  _vm.drugsData.length
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-warning",
                          attrs: { type: "button" },
                          on: { click: _vm.clearHistory },
                        },
                        [_vm._v("очистить\n            историю\n          ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-1" },
      _vm._l(_vm.drugsData, function (dd, i) {
        return _c("div", { key: i, staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _vm._v("Поиск: "),
            _c("strong", [_vm._v(_vm._s(dd.searchTitle))]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-outline-danger pull-right",
                on: {
                  click: function ($event) {
                    return _vm.removeByIndex(i)
                  },
                },
              },
              [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("table", { staticClass: "table table-sm table-hover" }, [
                _vm._m(0, true),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(
                      _vm.getSortedByCountry(dd.data),
                      function (d, countryId, i) {
                        return [
                          _c("tr", { class: { odd: i % 2 } }, [
                            _c(
                              "td",
                              {
                                attrs: {
                                  rowspan:
                                    d.length +
                                    1 +
                                    d.reduce(
                                      (acc, drug) =>
                                        acc +
                                        (drug?.extra_data?.prices ?? []).length,
                                      0
                                    ),
                                },
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.countries[countryId].selectTitle)
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(d, function (drug) {
                            return [
                              _c("tr", { class: { odd: i % 2 } }, [
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      rowspan:
                                        (drug?.extra_data?.prices ?? [])
                                          .length + 1,
                                    },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(drug.extra_data.main_title)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(_vm.printDate(drug.updated_at))
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      rowspan:
                                        (drug?.extra_data?.prices ?? [])
                                          .length + 1,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        drug.supplier_product?.data
                                          ?.active_ingredient
                                      ) + "\n                "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(drug.extra_data.prices, function (p) {
                                return _c("tr", { class: { odd: i % 2 } }, [
                                  _c("td", [_vm._v(_vm._s(p.title))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c("strong", [_vm._v(_vm._s(p.price))]),
                                  ]),
                                ])
                              }),
                            ]
                          }),
                        ]
                      }
                    ),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.getSortedByCountry(dd.data), function (d, countryId) {
                return false
                  ? _c(
                      "div",
                      { staticClass: "mr-2" },
                      [
                        _c("h5", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.countries[countryId].selectTitle)
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(d, function (drug) {
                          return _c("div", { staticClass: "card mb-1" }, [
                            _c(
                              "div",
                              { staticClass: "card-body" },
                              [
                                _c("p", { staticClass: "fs-18" }, [
                                  _vm._v(_vm._s(drug.extra_data.main_title)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex justify-content-between",
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          drug.supplier_product?.data
                                            ?.active_ingredient
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(_vm.printDate(drug.updated_at))
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(drug.extra_data.prices, function (p) {
                                  return _c(
                                    "div",
                                    { staticClass: "border-top" },
                                    [
                                      _c("p", [_vm._v(_vm._s(p.title))]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _c("strong", [_vm._v(_vm._s(p.price))]),
                                      ]),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ])
                        }),
                      ],
                      2
                    )
                  : _vm._e()
              }),
            ],
            2
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Действующее")]),
        _vm._v(" "),
        _c("th", [_vm._v("Фасовка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Цена")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }